import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, Label, LabelList, ResponsiveContainer, Text,
    LineChart, Line, CustomizedLegend} from 'recharts';
import barData from "../data/barData.json";
import lineData from "../data/lineData.json";

const BarLegendContent = styled.div`
    @media (max-width: 760px){
        display: flex; 
    }
    flex-direction: row;
    justify-content: center; 
    list-style-type: none;
    div.item{
        display: flex;
        flex-direction: content;
        justify-content: center;
    }
    @media (min-width: 760px){
        display: none; 
    }

`

const LegendIcon = styled.div`
    background-color: ${props=>props.color};
    margin-left: ${
        props => props.color == "#29A634" ?
            "0px" :
            "24px"
    };
    margin-right: 8px;
    width: 24px; 
    height: 24px; 
`

class CustomizedAxisTick extends PureComponent {
    render() {
            const {
            x, y, stroke, payload,
        } = this.props;

        var category='';
        switch (payload.value) {
            case 1:
                category = 'Day 0'; break; 
            case 2:
                category = '6 Months'; break;
            case 3:
                category = '1 Year'; break;          
            case 4:
                category = '1.5 Years'; break;
            case 5:
                category = '2 Years'; break; 
            case 6:
                category = '2.5 Years'; break; 
            case 7:
                category = '3 Years'; break;
            case 8:
                category = ''; break;
            case 9:
                category = '4 Years'; break;
            default:
                category = ''; break;
        }

        if (window.innerWidth < 1024){
            return (
                <g transform={`translate(${x},${y})`}>
                    <Text x={0} y={0} dy={16} textAnchor="middle" fill="#1D1D1F" angle={-30}>{category}</Text>
                </g>
            );
        } else{
            return (
                <g transform={`translate(${x},${y})`}>
                    <Text x={0} y={0} dy={16} textAnchor="middle" fill="#1D1D1F">{category}</Text>
                </g>
            );
        }
    }
}

class LineView extends PureComponent {
    constructor(props){
        super(props);
        this.tooltip = null; 
        this.point = null; 
        this.state={
            activeLine: '',
        };

        this.showToolTip = this.showTooltip.bind(this);
        this.hideToolTip = this.hideTooltip.bind(this);
    }
    
    showTooltip = (e) => {
        let x = Math.round(e.cx);
        let y = Math.round(e.cy);
        this.tooltip.style.opacity = "1";
        this.tooltip.style.transform = `translate(${x-27}px, ${y-52}px)`;
        this.tooltip.childNodes[0].innerHTML = (e.payload[e.dataKey] + '%');
    };
 
    hideTooltip = e => {
        this.tooltip.style.opacity = "0";
    };

    render() {
        const selectedOutcome = this.props.rates;

        return (
            <div className="ui-chart">
            <ResponsiveContainer width="100%" height={320} className={"respCont"}>
                <LineChart
                    data={selectedOutcome.milestone}
                    margin={{
                        top: 0, right: 30, left: 0, bottom: 0,
                    }}>
                <CartesianGrid/>
                <XAxis dataKey="tick" tickLine={false} interval={0} type="number" domain={[1,9]} 
                ticks={[1, 2, 3, 4, 5, 6, 7, 8, 9]} tick={<CustomizedAxisTick /> } tickSize={12}/>
                <YAxis axisLine={false} tickLine={false} unit="%" type="number" domain={[0, 100]}/>
                <Tooltip cursor={false} wrapperStyle={{ display: "none" }}/>
                <Legend iconType="plainline" iconSize={32} verticalAlign="bottom" layout="horizontal" align="center" wrapperStyle={{ paddingTop: "20px" }}/>
                <Line type="monotone" dataKey="With Transplant" 
                stroke = {selectedOutcome.id == "aGvHD" || selectedOutcome.id == "cGvHD" ? "#F2B824" : "#29A634"} 
                strokeWidth={2} activeDot={false}
                dot={{
                    onMouseOver:this.showTooltip,
                    onMouseLeave:this.hideTooltip,
                    r: 6 }} 
                animationDuration={1700}/>
                    {/* <LabelList dataKey="name"
                    position={"insideTop"} 
                    content={(x) => this.getCustomLabel(0, x, this.state.activeDot, selectedRates)}/> */}
                <Line type="monotone" dataKey="Without Transplant" 
                stroke = {selectedOutcome.id == "aGvHD" || selectedOutcome.id == "cGvHD" ? "#C99765" : "#00B3A4"} 
                strokeWidth={2} strokeDasharray="5 5" activeDot={false}
                dot={{onMouseOver:this.showTooltip,
                    onMouseLeave:this.hideTooltip,
                    r:6,
                    strokeDasharray:"0 0"}} 
                animationDuration={1700}/>
                </LineChart>
            </ResponsiveContainer>
            <div className="ui-chart-tooltip" ref={ref => (this.tooltip = ref)} >
                <div className="ui-chart-tooltip-content" />
            </div>
        </div>
        );
    }
}

class CustomizedBarAxisTick extends PureComponent {
    render() {
            const {
            x, y, stroke, payload,
        } = this.props;
        if (window.innerWidth > 760){
            return (
                <g transform={`translate(${x},${y})`}>
                    <Text x={0} y={0} dy={12} textAnchor="middle" fill="#1D1D1F">{payload.value}</Text>
                </g>
            );
        }
        else{
            return null;
        }
    }
}

class BarLegend extends PureComponent{
    render() {
        const { payload } = this.props;
        if (window.innerWidth < 760){
            return (
                <BarLegendContent>
                    {
                        payload.map((entry, index) => (
                        <div className = "item" key={`item-${index}`}>
                            <LegendIcon color={entry.color}></LegendIcon> 
                            <h5>{entry.value}</h5>
                        </div>
                        ))
                    }
                </BarLegendContent>
            );
        }
        else{
            return null;
        }
    }
}

class BarView extends PureComponent {
static jsfiddleUrl = 'https://jsfiddle.net/alidingling/30763kr7/';

handleMouseEnter(active, entry, index, e) {
    this.setState({activeBar: active.name});
}

handleMouseLeave(){
    this.setState({activeBar:''});
    this.tooltip.style.opacity = "0";
}


getCustomLabel(ix, props, active, data) {
    const {x, y, fill, index, value} = props;
    const d = data[index].value;
    if (value == active){
        this.tooltip.style.opacity = "1";
        this.tooltip.style.transform = `translate(${x+70}px, ${y-44}px)`;
        this.tooltip.childNodes[0].innerHTML = ( `${d}` + '%');
    }
    return null;
};

constructor(props){
    super(props);
    this.handleMouseEnter = this.handleMouseEnter.bind(this); 
    this.handleMouseLeave = this.handleMouseLeave.bind(this); 
    this.state={
        activeBar: ''
    };
}

render() {
    const selectedOutcome = this.props.rates;
    return (
        <div className="ui-chart">
        <ResponsiveContainer width="100%" height={320}>
            <BarChart
                data={selectedOutcome}
                margin={{
                top: 0, right: 0, left: 0, bottom: 0,}}
            >
                {/* <CartesianGrid strokeDasharray="3 3" /> */}
                <CartesianGrid vertical={false}/>
                <XAxis dataKey="name" tick={<CustomizedBarAxisTick /> } tickLine={false} tickSize={12}/>
                <YAxis axisLine={false} tickLine={false} tick={{ transform: 'translate(0, 0)' }} unit="%" type="number" domain={[0, 100]}/>
                {/* <Tooltip content={<CustomBarTooltip/>}cursor={{fill:'transparent'}} wrapperStyle={{backgroundColor:"#F5F5F5", padding: "8px", borderRadius:"2px"}} position={ y: this.y} isAnimationActive={false}/> */}
                <Bar 
                data={selectedOutcome.rates}
                dataKey="value"
                fill="#377879" 
                barSize={200} 
                radius={[8, 8, 0, 0]} 
                onMouseEnter={this.handleMouseEnter}
                onMouseLeave={this.handleMouseLeave}
                // label={(x) => this.getCustomLabel(0, x, selectedRates)}
                animationDuration={1600}>
                    <LabelList dataKey="name" content={(x) => this.getCustomLabel(0, x, this.state.activeBar, selectedOutcome.rates)}/>
                    {
                        selectedOutcome.rates.map((entry, index) => (
                            <Cell fill={selectedOutcome.id == ("aGvHD") || selectedOutcome.id == ("cGvHD") ? 
                            index === 0 ? '#F2B824' : '#C99765' : 
                            index === 0 ? '#29A634' : '#00B3A4'}/>
                        )) 
                    }
                </Bar>
                <Legend content={<BarLegend external ={this.props} />} display="none" iconType="plainline" iconSize={16} verticalAlign="bottom" layout="horizontal" align="center"
                payload={[{value: 'With Transplant', type:'square', 
                color: selectedOutcome.id == "aGvHD" || selectedOutcome.id == "cGvHD" ? "#F2B824" : "#29A634",
                id: 'ID01'}, 
                {value: 'Without Transplant', type:'square', 
                color: selectedOutcome.id == "aGvHD" || selectedOutcome.id == "cGvHD" ? "#C99765" : "#00B3A4", 
                id: 'ID02'}]} />
            </BarChart>
        </ResponsiveContainer>
        <div className="ui-chart-tooltip" ref={ref => (this.tooltip = ref)} >
            <div className="ui-chart-tooltip-content" />
        </div>
        </div>
    );
  }
}

export default class Graph extends React.Component {
    constructor(props){
        super(props);
        this.state={
            key: 1 
        }
    }
    render() {
        const { milestone, outcome, line } = this.props;
        if (line == false){
            if (!barData)
            return null; 
            const selectedMilestone = barData.milestones.find(m => m.name === milestone);
            if (!selectedMilestone)
            return null; 
            const selectedOutcome = selectedMilestone.outcomes.find(o => o.id === outcome);
            if (!selectedOutcome)
            return null; 
            // const selectedRates = selectedOutcome.rates; 
            // if (!selectedRates)
            // return null; 

            return (
                <BarView rates={selectedOutcome}></BarView>
            );

        } else{
            if (!lineData)
            return null; 
            const selectedOutcome = lineData.outcomes.find(o => o.id === outcome);
            if (!selectedOutcome)
            return null; 
            // const selectedRates = selectedOutcome.milestone; 
            // if (!selectedRates)
            // return null; 

            return (
                <LineView rates={selectedOutcome}></LineView> //milestone will be "" 
            )
        }
    }
}

export const GraphView = (milestone, outcome, line) => (
    <Graph milestone={milestone} outcome={outcome} line={line}></Graph>
)